import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@material-ui/core/';
import {
  Loader,
  GraphQLErrorWrapper,
  SuccessSnackBar,
} from '../../generic';

import GroupUserPermissionForm from './GroupUserPermissionForm';

import {
  GROUP_QUERY,
  GROUP_UPDATE_USER_PERMISSION_MUTATION,
} from '../queries';

const GroupUserPermissionEditModal = (props) => {
  const {
    group,
    userPermission,
    onClose,
  } = props;

  const { t } = useTranslation('translations');
  const [successOpen, setSuccessOpen] = React.useState(false);

  const [
    groupUpdateUserPermissionMutationAction,
    {
      loading,
      error,
    },
  ] = useMutation(GROUP_UPDATE_USER_PERMISSION_MUTATION, {
    refetchQueries: () => {
      const result = [
        {
          query: GROUP_QUERY,
          variables: {
            id: group.id,
          },
        },
      ];
      return result;
    },
    awaitRefetchQueries: true,
  });

  const handleFormSubmit = async (newUserPermission) => {
    try {
      const result = await groupUpdateUserPermissionMutationAction({
        variables: {
          input: {
            id: group.id,
            email: userPermission.email,
            roles: newUserPermission.roles,
          },
        },
      });
      if (result) setSuccessOpen(true);
      onClose();
    }
    catch (e) {
      // eslint-disable-next-line
      console.log(e);
    }
  };

  return (
    <>
      <SuccessSnackBar open={successOpen} setOpen={setSuccessOpen} message="common.operationSuccess" />
      <Dialog
        fullWidth
        maxWidth="md"
        open={userPermission !== null}
        onClose={onClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{t('userPermissions.edit.title')}</DialogTitle>
        <DialogContent>
          {error && <GraphQLErrorWrapper error={error} />}
          <Loader loading={loading} />
          <GroupUserPermissionForm
            group={group}
            userPermission={userPermission}
            onFormSubmit={handleFormSubmit}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

const propTypes = {
  group: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  userPermission: PropTypes.shape({
    email: PropTypes.string.isRequired,
    roles: PropTypes.arrayOf(PropTypes.string),
  }),
  onClose: PropTypes.func.isRequired,
};

const defaultProps = {
  userPermission: {},
};

GroupUserPermissionEditModal.propTypes = propTypes;

GroupUserPermissionEditModal.defaultProps = defaultProps;

export default GroupUserPermissionEditModal;
